import React, { createContext, useState, useEffect } from "react";
import axios from "axios";
import { config } from "./config";
import { useDispatch } from "react-redux";
import { useFetch } from "./fetch";
import { clearCart,pushCart } from "./cartslice";

// Create context
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // to store logged-in user data
  const [isLoggedIn, setIsLoggedIn] = useState(false); // Track login state
  const [isLoading, setIsLoading] = useState(true);
  const [isDataLoading , setIsDataLoading] = useState(true);
  const [isVerifed,setIsVerified] = useState(null);
  const dispatch = useDispatch();

  const [products, setProducts] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true); // Controls whether there are more products to load

  const { data: cartData, isLoading: dataLoading, isError } = useFetch(
       user?.phone && isLoggedIn ? `api/usercart?userId=${user?.phone}` : null,  // Include the userId in the query string
      config.serverURL
    );
  const { data:fetchedProducts, error : productsError, isLoading:productsLoading } = useFetch(
        user?.phone && isLoggedIn ? `api/products?page=${page}` : null,
        config.serverURL
  );

    const login = (userData) => {
      //console.log(userData);
      setUser(userData); // Set user data
      setIsLoggedIn(true); // Set isLoggedIn to true after login
    };
  
    const logout = () => {
      axios
        .post(
          config.serverURL + "/api/logout", // Backend route for logout
          {}, // Empty body for POST request
          { withCredentials: true } // Options object (for cookies and credentials)
        )
        .then(() => {
          // Clear user state and login status
          setUser(null); // Clear user data
          setIsLoggedIn(false); // Set isLoggedIn to false
          setIsVerified(false);
          //console.log("User logged out and cookies cleared.");
          //navigate('/login');
        })
        .catch((error) => {
          console.error("Logout failed:", error);
        });
    };
  
    const register = (userData) => {
      setUser(userData); // Set user data after registration
      setIsLoggedIn(true); // Set isLoggedIn to true after registration
      setIsVerified(false);
    };
    
    
  useEffect(() => {
    axios
      .get(config.serverURL + "/api/authLogin", { withCredentials: true }) // API call to validate token
      .then((response) => {
        setUser(response.data.user); // If token is valid, set the user data
        setIsLoggedIn(true); // Set isLoggedIn to true if user is logged in
        //console.log('Is Logged In:', user?.phone); // Check if isLoggedIn state is updated
      })
      .catch((error) => {
        setIsLoggedIn(false); // If error (user is not logged in), set isLoggedIn to false
        //console.error("Token validation failed:", error);
      })
      .finally(() =>{
        setIsLoading(false);
      });
  }, []);
  useEffect(() => {
    if (!dataLoading && isLoggedIn && user && cartData?.success === true) {
        //console.log(cartData);

        // Case 1: User not found
        if (!cartData.user) {
            console.warn(cartData.message); // Log the message
            logout(); // Logout the user
        } 
        // Case 2: User found but not verified
        else if (!cartData.userVerified) {
            console.warn(cartData.message); // Warn about unverified user
            setIsVerified(false); // Update verification status
        } 
        // Case 3: User found and verified
        else if (cartData.userVerified) {
            setIsVerified(true); // Mark user as verified
        }

        // Manage cart data (always run this part)
        if (cartData.products && cartData.products.length > 0) {
            dispatch(clearCart()); // Clear the Redux cart
            dispatch(pushCart(cartData.products)); // Add products to Redux cart
        } else {
            dispatch(clearCart()); // If no products, clear the cart
        }
    }
}, [cartData, dispatch, logout, user, isLoggedIn, dataLoading]);
// 🔥 Handle Infinite Scroll Product Fetching
useEffect(() => {
  if (fetchedProducts?.data && Array.isArray(fetchedProducts?.data)) {
    setProducts((prev) => {
      const newProducts = fetchedProducts.data.filter(
        (item) => !prev.some((existingItem) => existingItem.id === item.id)
      );
      return [...prev, ...newProducts];
    });

    // ✅ सही तरीके से `hasMore` सेट करें
    setHasMore(page < fetchedProducts?.totalPages);
  }
}, [fetchedProducts, page]);


  return (
     <AuthContext.Provider value={{ user, isLoggedIn,isLoading,isVerifed, login, logout, register,products,productsError,productsLoading,page,setPage,hasMore}}> 
    
      {children} {/* This will wrap all components in the app */}
    </AuthContext.Provider>
  );
};
export default AuthContext;
//   products,productsError,productsLoading,page,setPage,hasMore}}>